import type { InjectionKey, ShallowRef } from "vue";

export const GoogleSymbol: InjectionKey<ShallowRef<typeof google | undefined>> = Symbol();
export const MapSymbol: InjectionKey<ShallowRef<google.maps.Map | undefined>> = Symbol();
